import { createStyles, makeStyles } from '@hawkins/styles';
/**
 * Styles to generate for the component, the order that
 * they are displayed are the order that they are rendered.
 *
 * Keep that in mind when creating new styles and how the styles
 * will override.
 */
export function dividerStyles(theme) {
    var hawkins = theme.hawkins, hawkinsVariables = theme.hawkinsVariables;
    return createStyles({
        /** Class name applied to the root of the component */
        root: {},
        /** Class name applied when the variant is horizontal */
        horizontal: {
            height: hawkins.ui.borderWidthRegular,
            margin: "".concat(hawkinsVariables.spacingValues.space0 / 2, "px 0px"),
        },
        /** Class name applied when the variant is vertical */
        vertical: {
            margin: "0px ".concat(hawkinsVariables.spacingValues.space0 / 2, "px"),
            width: hawkins.ui.borderWidthRegular,
        },
        /** Class name applied when the variant is table */
        table: {
            margin: "".concat(hawkinsVariables.spacings.space0, " ").concat(hawkinsVariables.spacings.space1),
            width: hawkins.ui.borderWidthRegular,
        },
        /** Class name applied when the color is light */
        light: {
            backgroundColor: hawkins.ui.borderColorLight,
        },
        /** Class name applied when the color is xLight */
        xLight: {
            backgroundColor: hawkins.ui.borderColorXlight,
        },
    });
}
export var useDividerStyles = makeStyles(dividerStyles, { name: 'Hawkins-Divider' });
